import React, { useEffect } from 'react';
import { Prompt, useLocation } from 'react-router-dom';

import { UNSAVED_MESSAGE } from '@silverfort-nodelibs/common/utils/consts';

const UnsavedPrompt = ({ isDirty }) => {
    const location = useLocation();

    useEffect(() => {
        const onUnload = (event) => {
            event.preventDefault();
            event.returnValue = UNSAVED_MESSAGE;
            return UNSAVED_MESSAGE;
        };
        if (isDirty) {
            window.addEventListener('beforeunload', onUnload);
        } else {
            window.removeEventListener('beforeunload', onUnload);
        }
        return () => {
            window.removeEventListener('beforeunload', onUnload);
        };
    }, [isDirty]);

    return (
        <Prompt
            when={isDirty}
            message={(newLocation) => {
                return location.pathname === newLocation.pathname ? true : UNSAVED_MESSAGE;
            }}
        />
    );
};

export default React.memo(UnsavedPrompt);
